// function that returns the previous letter of the alphabet
export function getPreviousLetter(letter) {
    if ((letter.length === 1 && letter === 'a')) {
        return letter;
    } else if (letter.length !== 1) {
        throw new Error('The argument must be a single letter');
    }
    return String.fromCharCode(letter.charCodeAt(0) - 1);
}